import { FC, ReactNode } from 'react';
import EditDesiredContent from '../EditDesiredContent';
import EditDesiredTitle from '../EditDesiredTitle';
import { Root } from './styled';
import { DesiredValue, Range } from 'models';
import { FieldErrors, FieldValues } from 'react-hook-form';

type Props = {
  id: string;
  children?: ReactNode;
  title: string;
  itemKey: string;
  value?: string;
  writable?: boolean;
  type?: string;
  range?: Range;
  register: any;
  desired?: DesiredValue;
  errors?: FieldErrors<FieldValues>;
  onDesiredRemoved?: (id: string, resourceId: string) => void;
};

const EditDesiredItem: FC<Props> = ({
  id,
  children,
  title,
  itemKey,
  value,
  writable,
  type,
  range,
  register,
  desired,
  errors,
  onDesiredRemoved,
}) => {
  return (
    <Root>
      {children && (
        <div>
          <EditDesiredTitle title={title}></EditDesiredTitle>
          <EditDesiredContent
            id={id}
            itemKey={itemKey}
            desired={desired}
            onDesiredRemoved={onDesiredRemoved}
          >
            {children}
          </EditDesiredContent>
        </div>
      )}
      {value && (
        <div>
          <EditDesiredContent
            id={id}
            title={title}
            value={value}
            itemKey={itemKey}
            writable={writable}
            type={type}
            range={range}
            register={register}
            desired={desired}
            errors={errors}
            onDesiredRemoved={onDesiredRemoved}
          >
            {children}
          </EditDesiredContent>
        </div>
      )}
    </Root>
  );
};

export default EditDesiredItem;
